Object.defineProperty(exports, "__esModule", { value: true });
var gtm = {
    gtm_push: function (gtm_event, gtm_category, gtm_action, gtm_label, gtm_extra_params, callback) {
        var data = {
            "event": gtm_event,
            "category": gtm_category,
            "action": gtm_action,
            "label": gtm_label,
        };
        for (var param in gtm_extra_params) {
            data[param] = gtm_extra_params[param];
        }
        if (callback) {
            data['eventCallback'] = callback;
            setTimeout(callback, 1000);
        }
        if (window['dataLayer']) {
            window['dataLayer'].push(data);
        }
    }
};
window['gtm'] = gtm;
exports.default = gtm;
